export const homeFaqs = [
  {
    q: 'Are degrees from your partner universities recognized in India?',
    a: 'Yes. All our medical and dental partner universities are recognized by WHO and NMC India (FMGE / NExT eligible). Our European universities are EU-accredited and recognized worldwide.'
  },
  {
    q: 'Is the NEET exam required for MBBS abroad?',
    a: 'NEET qualification is mandatory for Indian students who want to practice medicine in India after their foreign MBBS. We help you understand intake requirements specific to each university.'
  },
  {
    q: 'What is the average tuition fee for studying abroad?',
    a: 'Tuition varies by program and country. MBBS starts from ~$3,500/year in Uzbekistan to ~$8,000/year in Bulgaria. BSc Nursing starts at ~$3,000/year, while AI/Cybersecurity and MBA programs range from €4,500 to €8,000/year. See each program page for exact figures.'
  },
  {
    q: 'Does Patrick\'s Edu Care provide visa support?',
    a: 'Absolutely. We provide end-to-end visa assistance including documentation, embassy appointment booking, and interview preparation. Our visa approval rate is above 95%.'
  },
  {
    q: 'Is the medium of instruction English?',
    a: 'Yes, all the programs we offer — MBBS, Nursing, AI, Cybersecurity, BBA, MBA, Dentistry and Veterinary Medicine — are taught in English at our partner universities.'
  },
  {
    q: 'Can I work part-time while studying abroad?',
    a: 'Most of our destination countries (Germany, Hungary, Slovakia, Bulgaria, Georgia) allow international students to work 15–20 hours per week during the semester. We guide you on local work permits.'
  },
  {
    q: 'How early should I apply?',
    a: 'We recommend applying at least 4–6 months before your intake. For the September intake, start by March–April. For the February intake, start by August. Earlier applications get priority hostel allocation.'
  },
  {
    q: 'Do you charge a counselling fee?',
    a: 'Your first 1-on-1 counselling session with our experts is completely free. Subsequent service charges depend on the program and university chosen — fully transparent, with no hidden costs.'
  }
];

export const homeFaqJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: homeFaqs.map((f) => ({ '@type': 'Question', name: f.q, acceptedAnswer: { '@type': 'Answer', text: f.a } })),
};
